var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 125",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.815,41.455V29.33c0-4.136-3.364-7.5-7.5-7.5H52.255l-8.001-7H13.149c-4.136,0-7.5,3.364-7.5,7.5v38.168  c0,4.136,3.364,7.5,7.5,7.5h37.878C53.205,77.809,61.97,85.17,72.427,85.17c12.089,0,21.924-9.835,21.924-21.924  C94.351,51.965,85.784,42.649,74.815,41.455z M50.51,62.998h-37.36c-1.379,0-2.5-1.121-2.5-2.5V22.33c0-1.379,1.121-2.5,2.5-2.5  h29.226l8.001,7h16.939c1.379,0,2.5,1.121,2.5,2.5v12.153C59.034,42.77,50.634,51.905,50.51,62.998z M72.427,80.17  c-9.332,0-16.924-7.592-16.924-16.924s7.592-16.924,16.924-16.924s16.924,7.592,16.924,16.924S81.759,80.17,72.427,80.17z   M72.315,51.111c-1.381,0-2.5,1.119-2.5,2.5v10.333c0,1.381,1.119,2.5,2.5,2.5s2.5-1.119,2.5-2.5V53.611  C74.815,52.23,73.696,51.111,72.315,51.111z M72.315,68.944c-1.381,0-2.5,1.119-2.5,2.5v0.167c0,1.381,1.119,2.5,2.5,2.5  s2.5-1.119,2.5-2.5v-0.167C74.815,70.063,73.696,68.944,72.315,68.944z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.4fbd563e.svg";
export { ForwardRef as ReactComponent };